import * as types from './types';
import { Moment } from 'moment';
import * as constants from './constants';

export const startFetchApp = (id: number): types.StartFetchAction => {
    return { type: constants.START_FETCH_APP, id }
}

export const successFetchApp = (application: types.Application): types.SuccessFetchAction => {
    return { type: constants.SUCCESS_FETCH_APP, application }
}

export const checkPending = (application: types.Application): types.CheckPendingAction => {
    return { type: constants.CHECK_PENDING, application }
}

export const setPhaseStatus = (phase: types.AppPhase, status: types.PhaseStatus): types.SetPhaseStatusAction => {
    return { type: constants.SET_PHASE_STATUS, phase, status }
}

export const startCreate = (id: number): types.StartCreateAction => {
    return { type: constants.START_CREATE, id }
}

export const startDestroy = (id: number): types.StartDestroyAction => {
    return { type: constants.START_DESTROY, id }
}

export const startCompile = (id: number): types.StartCompileAction => {
    return { type: constants.START_COMPILE, id }
}

export const startInit = (id: number): types.StartInitAction => {
    return { type: constants.START_INIT, id }
}

export const startBuildBackend = (id: number): types.StartBuildBackendAction => {
    return { type: constants.START_BUILD_BACKEND, id }
}

export const startStart = (id: number): types.StartStartAction => {
    return { type: constants.START_START, id }
}

export const startStop = (id: number): types.StartStopAction => {
    return { type: constants.START_STOP, id }
}

export const startPinging = (name: string, timeout: number): types.StartPingingAction => {
    return {
        type: constants.START_PINGING,
        name,
        timeout
    }
}

export const doStartPinging = (): types.DoStartPingingAction => {
    return { type: constants.DO_START_PINGING }
}

export const successPing = (): types.SuccessPingAction => {
    return { type: constants.SUCCESS_PING }
}

export const failPing = (): types.FailPingAction => {
    return { type: constants.FAIL_PING }
}

export const pingingTimeout = (): types.PingingTimeoutAction => {
    return { type: constants.PINGING_TIMEOUT }
}

export const successStop = (): types.SuccessStopAction => {
    return { type: constants.SUCCESS_STOP }
}

export const startBuild = (id: number): types.StartBuildAction => {
    return { type: constants.START_BUILD, id }
}

// export const endBuild = (): types.EndBuildAction => {
//     return { type: constants.END_BUILD }
// }

export const startLaunch = (id: number, name: string): types.StartLaunchAction => {
    return { type: constants.LAUNCH_START, id, name }
}

// Hearbeat
export const startHeartbeat = (name: string): types.HearbeatAction => {
    return { type: constants.HEARTBEAT_START, name }
}

export const successHeartbeat = (): types.HearbeatAction => {
    return { type: constants.HEARTBEAT_SUCCESS }
}

export const failureHeartbeat = (): types.HearbeatAction => {
    return { type: constants.HEARTBEAT_FAILURE }
}

export const stopHeartbeat = (): types.HearbeatAction => {
    return { type: constants.HEARTBEAT_STOP }
}

export const optimisticStartAction: (milestone: types.Milestone, timestamp: Moment) => types.OptimisticStartAction = (milestone, timestamp) => {
    return { type: constants.OPTIMISTIC_START, milestone, timestamp }
}

export const reset: () => types.ResetAction = () => {
    return { type: constants.RESET }
}
